import { cn } from "@babybjorn/ui";
import type { FC, HTMLAttributes } from "react";
import * as s from "./Tag.module.scss";

type TagProps = HTMLAttributes<HTMLDivElement> & {
	label: string;
	alwaysSmall?: boolean;
};

const Tag: FC<TagProps> = ({ label, alwaysSmall, ...props }) => {
	return (
		<div
			className={cn(s.tagContainer, props.className, {
				[s.alwaysSmall]: alwaysSmall,
			})}
		>
			<span className={s.tag}>{label}</span>
		</div>
	);
};
export default Tag;
